<template>
  <div style="min-height: calc(100vh - 70px);display: flex;">
    <section v-if="step===1" class="m-content m-content-full align-items-center forget">
      <div class="gate_center col">
        <div class="row  justify-content-center">
          <div class="card col-12 col-md-8 col-lg-5 text-center">
            <div class="card__title text-center">
              <h3>Report Suspicious Activity</h3>
              <p class="text-center input--hint"> Block Account by entering your phone number </p>
            </div>
            <div class="card__body">
              <div class="row">
                <div class="col-12">
                  <div class="material--input--group">
                    <input v-model="phonenumber"
                           v-ep-restrict.number
                           class="phone"
                           maxlength="11" name="phone" required
                           title="Phone number"
                           type="text">
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <div
                        :class="`vuelidate-error ${$v.phonenumber.$invalid ? 'vuelidate-error-show' : 'vuelidate-error-hide'}`"
                    >
                      <div v-if="!$v.phonenumber.required">Phone number is required.</div>
                      <div
                          v-if="!$v.phonenumber.minLength"
                      >Please enter an 11 digit phone number.
                      </div>
                    </div>
                  </div>
                  <div class="material--input--group">
                    <textarea v-model="reason"
                              name="reason"
                              required
                              title="Reason for blocking account"
                              type="text">
                    </textarea>
                    <span class="highlight"></span>
                    <div class="text-left" v-if="!$v.reason.required">Please state the reason for blocking this account (minimum 15 characters)</div>
                    <div
                        v-if="!$v.reason.minLength"
                    class="text-left">Please provide more context
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card__footer">
              <button :disabled="$v.phonenumber.$invalid || $v.reason.$invalid" class="btn m-btn--square btn-block btn-primary btn-lg m-btn wizard-next"
                      type="button"
                      @click="getOTP()">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="step===2" class="m-content m-content-full align-items-center">
      <div class="gate_center col">
        <div class="row  justify-content-center">
          <div class="card col-12 col-md-8 col-lg-5">
            <div class="card__title">
              <h3 class="text-center">Enter OTP</h3>
              <p class="input--hint">Enter OTP sent to the number</p>
            </div>
            <pincode
                ref="verifyPincode"
                class_name="pincode_wrapper"
                name="pincode"
                v-bind:input="pincodes"
                v-on:onFishied="verifyBlockOTP()"
            />
            <button class="btn m-btn--square btn-block btn-primary btn-lg m-btn wizard-next"
                    type="button"
                    @click="getOTP()">
              Resend OTP
            </button>
          </div>
        </div>
      </div>
    </section>
    <div class="m-gate_bg gate-full gate_bg_not_mobile">
      <img alt="" src="./../../../static/media/demo/default/img/misc/forget_bg.png">
    </div>
    <div class="m-gate_bg gate_bg_only_mobile ">
      <img alt="" src="./../../../static/media/demo/default/img/misc/forget_bg-mobile.png">
    </div>
  </div>

</template>
<script>
import Datepicker from 'vuejs-datepicker';
import pincode from "../../components/pincode";
import {requestOTPToBlockAccount, verifyBlockOTP} from "../../api/user/userService";
import {phoneNumberValidator, blockReasonValidation} from "../../utils/inputValidators";

export default {
  mounted() {
    this.$swal.close();
    // if we are coming from idle state redirect grab phone number from params
    if (this.$route.params.idleRedirectPhoneNumber) {
      this.phonenumber = this.$route.params.idleRedirectPhoneNumber;

    }
    $('body').addClass('m--bg-white').removeClass('m-content--skin-light2')
    $('.m-brand--skin-light').removeClass('m-brand--skin-light2')
    $('.m-stack__item.m-brand.m-brand--skin-light').removeClass('m-brand--skin-light')
  },
  components: {
    Datepicker,
    pincode,
  },
  data: () => ({
    step: 1,
    is_submiting: false,
    phonenumber: null,
    reason: "",
    pincodes: ["", "", "", "", "", ""]
  }),
  validations: {
    phonenumber: {
      ...phoneNumberValidator
    },
    reason: {
      ...blockReasonValidation
    }
  },
  methods: {
    getOTP() {
      this.$store.dispatch("loader", true);
      requestOTPToBlockAccount(this.phonenumber)
          .then(response => {
            if (this.step < 2) {
              this.step++;
            }
          }).catch(error => {
        this.is_submiting = false;
        this.$store.dispatch("handleError", error);
      }).finally(() => {
        this.$store.dispatch("loader", false);
      });
    },
    verifyBlockOTP() {
      if (this.pincodes.join("").length !== 6) {
        this.$swal({
          imageUrl: "/images/svg/Error.svg",
          title: "Invalid verification code."
        });
      } else {
        this.$store.dispatch("loader", true);
        verifyBlockOTP(this.phonenumber,  this.reason, this.pincodes.join(""))
            .then(response => {
              this.$swal({
                title: 'Success',
                text: response.response.message,
                showCloseButton: true,
                onClose: () => {
                  this.$store.dispatch("redirect", "login");
                }
              });
            })
            .catch(error => {
              this.password = null;
              this.pincodes = ["", "", "", "", "", ""];
              this.$store.dispatch("handleError", {...error, pincodeRef: this.$refs.verifyPincode});
            })
            .finally(() => {
              this.$store.dispatch("loader", false);
            });
      }
    }
  }
};
</script>

<style scoped>
.vuelidate-error {
  text-align: left
}
</style>
